module.exports = __webpack_public_path__ + "static/media/blue-s.c305593f.svg";